import * as React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';

const Explore: React.FC = () => {
    const { t } = useLang('Explore');
    const { locale } = getLocal();

    const MoreBtn = () => {
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4.39453L10 8.39453L6 12.3945" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        );
    };

    const extd3mLink = React.useMemo(() => {
        const maps: Record<string, string> = {
            us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
            ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
        };
        return maps[locale] || '';
    }, [locale]);

    const extd3uLink = React.useMemo(() => {
        const maps: Record<string, string> = {
            us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station',
            ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station',
        };
        return maps[locale] || '';
    }, [locale]);

    const list = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            btn: t('item1_btn'),
            link: extd3mLink,
            img: 'https://websiteoss.ecoflow.com/upload/image/1759056110135/01.png',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            btn: t('item2_btn'),
            link: extd3uLink,
            img: 'https://websiteoss.ecoflow.com/upload/image/1759056109966/02.png',
        },
    ];

    const handleClick = (item: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: item.title,
            position: t('title'),
        });
    };

    return (
        <div className={`page-explore ${styles.Explore} GtmModuleData-section`} data-section-id="d3c-Explore">
            <div className="eco-content">
                <EcoSectionCommon className="section-content" title={t('title')} />
                <div className="explore-content">
                    <EcoImg
                        className="img-bg"
                        isOpenLazy={true}
                        pc="https://websiteoss.ecoflow.com/figma-uploads/1758187083183-fcqunv-compressed-%E9%9B%86%E5%90%88kv.jpg"
                        pad="https://websiteoss.ecoflow.com/figma-uploads/1758187180019-0387bn-compressed-%E9%9B%86%E5%90%88KV.jpg"
                        h5="https://websiteoss.ecoflow.com/figma-uploads/1758187121762-6601l0-compressed-Frame.jpg"
                    />
                    <div className="item-bg">
                        <div className="items-container">
                            {list.map((item, index) => {
                                return (
                                    <div className="item" key={index}>
                                        <EcoImg className="item-img" pc={item.img} isOpenLazy={true} />
                                        <div className="item-content">
                                            <div className="item-title">{item.title}</div>
                                            <div className="item-desc">{item.desc}</div>

                                            {item.link && (
                                                <EcoLink className="item-link" href={item.link} onClick={() => handleClick(item)}>
                                                    <span className="item-link-text">{item.btn}</span>
                                                    <MoreBtn />
                                                </EcoLink>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default Explore;
